import { ProjectedValue, SalesCommission } from '.';

export type TProjectedValueSalesCommissionId = number;

export interface ProjectedValueSalesCommission {
  id: TProjectedValueSalesCommissionId;
  projected_value: ProjectedValue;
  sales_commission: SalesCommission;
}
